import { http } from '@/utils/http'
export const ENTITYBASE = window.$envUtils('VUE_APP_ENTITY_SERVICE')

export const getWordClassList = (params) => {
  return http.get(`${ENTITYBASE}/manager/wordClass/wordClass`, { params })
}

export const addWordClass = (data) => {
  return http.post(`${ENTITYBASE}/manager/wordClass/wordClass`, { data })
}

export const editWordClass = (data) => {
  return http.put(`${ENTITYBASE}/manager/wordClass/wordClass`, { data })
}

export const deleteWordClass = (data) => {
  return http.delete(`${ENTITYBASE}/manager/wordClass/wordClass`, { data })
}
